import { useHeaderContext } from '@/creditflowresearch/application/Header/HeaderContext';
import SearchResultsMenu from './SearchResultsMenu';

interface IProps {
  variant?: 'default' | 'creditflow',
}

const SearchResultsMenuContainer = ({ variant }: IProps) => {
  const { isSearchFetching } = useHeaderContext();

  return <SearchResultsMenu isSearchFetching={ isSearchFetching } variant={ variant } />;
};

export default SearchResultsMenuContainer;
